// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : created reducer
// MODIFIED DATE : 06-10-2025

import ENACHReportActionTypes from './MandateReport.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchENACHReportResponse: null,
	fetchENACHReportArr: [],
	fetchENACHMandateReportResponse: null,
	fetchENACHMandateReportArr: [],
	fetchENACHMandateRegisterReportResponse: null,
	fetchENACHMandateCancellationReportResponse: null,
};

const mandateReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START OF GET MANDATE REPORT  ******************** */
		case ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_SUCCESS:
			return {
				...state,
				fetchENACHMandateReportResponse: action.payload,
				fetchENACHMandateReportArr: docodeHexResponse(
					action.payload,
					'EnachMandateReportListKey',
				),
			};

		case ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_FAILURE:
			return { ...state, fetchENACHMandateReportResponse: action.payload };

		case ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchENACHMandateReportResponse: null,
			};
		/** *********************  END OF GET MANDATE REPORT  ******************** */

		default:
			return state;
	}
};
export default mandateReducer;
